export default __webpack_public_path__ + "static/media/title2.cd5c73f9.svg";